<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<section class="authorizations">
  <div style="width: 100%; max-width: 1196px !important">
    <div class="autorizationsContainer">
      <header class="authorizations--header">
        <section class="authorizations--header__btnContainer">
          <mat-button-toggle-group
            class="btnGroup"
            name="favoriteColor"
            aria-label="Favorite Color"
          >
            <mat-button-toggle
              (click)="verifyAuthorizationType('requests')"
              class="toggleBtn"
              checked
              value="Requests"
              >{{ 'requests' | i18next | uppercase }}</mat-button-toggle
            >
            <mat-button-toggle
              class="toggleBtn"
              (click)="verifyAuthorizationType('transfers')"
              value="Transfers"
              >{{ 'transfers' | i18next | uppercase }}</mat-button-toggle
            >
            <mat-button-toggle
              class="toggleBtn"
              (click)="verifyAuthorizationType('redplates')"
              value="RedPlates"
              [disabled]="!enableRedPlates"
              [style]="!enableRedPlates ? 'background-color:#565554;' : ''"
              >{{ 'redPlate' | i18next | uppercase }}</mat-button-toggle
            >
          </mat-button-toggle-group>
        </section>
      </header>
      <main class="main">
        <nav class="main--nav">
          <div class="main--nav__btnContainer">
            <button
              [style]="{
                'border-bottom':
                  data === RequestStatus.PENDING_APPROVAL
                    ? 'solid 0.1em #C8F546'
                    : 'none'
              }"
              class="main--nav__btn"
              (click)="changeRequestType(RequestStatus.PENDING_APPROVAL)"
              matButton
            >
              {{ 'pending' | i18next | uppercase }}
            </button>
            <button
              [style]="{
                'border-bottom':
                  data === RequestStatus.APPROVED
                    ? 'solid 0.1em #C8F546'
                    : 'none'
              }"
              class="main--nav__btn"
              *ngIf="authorizationType !== 'transfers'"
              (click)="changeRequestType(RequestStatus.APPROVED)"
              matButton
            >
              {{ 'authApproved' | i18next | uppercase }}
            </button>
            <button
              [style]="{
                'border-bottom':
                  data === RequestStatus.REJECTED
                    ? 'solid 0.1em #C8F546'
                    : 'none'
              }"
              class="main--nav__btn"
              (click)="changeRequestType(RequestStatus.REJECTED)"
              matButton
            >
              {{ 'rejected' | i18next | uppercase }}
            </button>
          </div>
          <div class="main--nav__actionsContainer">
            <mat-checkbox
              color="primary"
              #all
              [checked]="checkSelectAll"
              *ngIf="data !== RequestStatus.APPROVED"
              class="checkbox-label"
              (change)="selectAll(all.checked)"
              ><span class="main--nav__actionsContainer--selectAll">{{
                'btnSelectAll' | i18next
              }}</span></mat-checkbox
            >
            <button
              class="main--nav__actionsContainer--btn btn confirmDark"
              *ngIf="data === RequestStatus.PENDING_APPROVAL"
              (click)="handleAuthorizations('REJECTED')"
            >
              {{ 'btnReject' | i18next | uppercase }}
            </button>
            <button
              class="main--nav__actionsContainer--btn btn confirmDark"
              *ngIf="data !== RequestStatus.APPROVED"
              (click)="handleAuthorizations('APPROVED')"
            >
              {{ 'approve' | i18next | uppercase }}
            </button>
          </div>
        </nav>
        <section>
          <p
            class="no-request"
            *ngIf="noRequest && data === RequestStatus.PENDING_APPROVAL"
          >
            {{ 'noRequestPending' | i18next }}
          </p>
          <p
            class="no-request"
            *ngIf="noRequest && data === RequestStatus.APPROVED"
          >
            {{ 'noRequestApproved' | i18next }}
          </p>
          <p
            class="no-request"
            *ngIf="noRequest && data === RequestStatus.REJECTED"
          >
            {{ 'noRequestRejected' | i18next }}
          </p>
          <div class="text-center spinner-container" *ngIf="spinner">
            <div class="spinner-border spinner" role="status"></div>
          </div>
          <app-list-item
            (allSelectedChangeEmitter)="updatedAllSelected($event)"
            (pageEmitter)="updatePage($event)"
            [allSelected]="allSelected"
            [data]="authorizations"
            [dataPagination]="dataPagination"
            [authorizationType]="authorizationType"
            [status]="data"
            type="authorizations"
          ></app-list-item>
        </section>
      </main>
    </div>
  </div>
</section>
